import { useMutation } from '@tanstack/react-query'
import { adminApi } from '../adminApi.js'
import type { DevResetResponse, WalletVerifyResponse } from '../types.js'

/**
 * Runs the Google Wallet config verification (writes a DRAFT LoyaltyClass
 * against the configured issuer). One-shot — no cached query, the admin clicks
 * the button on the System page and reads the result. Confirms write access
 * only — not publishing access (see System.tsx).
 */
export function useWalletVerify() {
  return useMutation({
    mutationFn: () => adminApi.post<WalletVerifyResponse>('/wallet/verify'),
  })
}

/**
 * Nuclear staging reset — wipes every tenant-scoped row, preserves admin
 * login + plan_tier_settings. Route is only mounted when NODE_ENV !==
 * 'production' (see routes/admin/dev-reset.ts); a click in prod returns 404
 * and surfaces here as an error. Requires `confirm: 'NUKE'` in the body.
 */
export function useDevReset() {
  return useMutation({
    mutationFn: () =>
      adminApi.post<DevResetResponse>('/dev/reset', { confirm: 'NUKE' }),
  })
}
